import {
  AppwideDrawerContentType,
  EntityAdminDrawerHeader,
  NotificationVariants,
  useAppwideDrawerContext,
  useGlobalToasts,
  type AssetTransaction,
} from '@talos/kyoko';
import { useCallback } from 'react';
import { ModifyAssetTransactionDrawer } from './ModifyAssetTransactionDrawer';

export function useModifyAssetTransactionDrawer() {
  const { openDrawer, closeDrawer } = useAppwideDrawerContext();
  const { add: addToast } = useGlobalToasts();

  const showSuccessToast = useCallback(() => {
    addToast({
      text: 'Cash transaction updated.',
      variant: NotificationVariants.Positive,
    });
  }, [addToast]);

  const openModifyAssetTransactionDrawer = useCallback(
    (transaction: AssetTransaction) => {
      openDrawer({
        type: AppwideDrawerContentType.ModifyAssetTransaction,
        title: 'Cash Transaction',
        width: 420,
        drawerHeaderDesign: 'flex',
        flexHeaderTitle: () => <EntityAdminDrawerHeader drawerTitle="Cash Transaction" selectedCount={1} />,
        renderContent: () => (
          <ModifyAssetTransactionDrawer transaction={transaction} onClose={closeDrawer} onSuccess={showSuccessToast} />
        ),
      });
    },
    [closeDrawer, openDrawer, showSuccessToast]
  );

  return { openModifyAssetTransactionDrawer, closeModifyAssetTransactionDrawer: closeDrawer };
}
